import { render, staticRenderFns } from "./OutOfCreditsModal.vue?vue&type=template&id=7283a632&"
import script from "./OutOfCreditsModal.vue?vue&type=script&lang=ts&"
export * from "./OutOfCreditsModal.vue?vue&type=script&lang=ts&"
import style0 from "./OutOfCreditsModal.vue?vue&type=style&index=0&id=7283a632&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports